import React, { useEffect } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { DialogContent } from 'Views/Page/Content/Modal/Components';

const Layout = () => {
  const { onSubmit } = useMetaLayoutContext();

  useEffect(() => {
    onSubmit();
  }, []);

  return (
    <>
      <MetaControlField attr={'title'} />
      <DialogContent>
        <MetaControlField attr={'loadingMessage'} />
      </DialogContent>
    </>
  );
};
Layout.defaultProps = {
};
Layout.propTypes = {
};
export default Layout;
